import { SVGProps } from "react"

import { IconProps } from "../nav-icons/icon.types.ts"

export const IconSuppliers = ({ hovered, ...props }: IconProps) => {
  if (hovered) return <SuppliersHover {...props} />
  else return <SuppliersDefault {...props} />
}

const SuppliersDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 25a9 9 0 1 1 18 0v1H7v-1Z"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M11.008 10.544a4.987 4.987 0 1 0 9.974 0V7.392a4.392 4.392 0 0 0-4.392-4.393H15.4a4.392 4.392 0 0 0-4.392 4.393v3.152Z"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M11.322 7.141a3.972 3.972 0 0 0 3.843 2.97h1.657c1.847 0 3.4-1.261 3.843-2.97h-9.343ZM19 17a3 3 0 1 1-6 0"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
)

const SuppliersHover = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 25a9 9 0 1 1 18 0v1H7v-1Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M11.008 10.544a4.987 4.987 0 1 0 9.974 0V7.392a4.392 4.392 0 0 0-4.392-4.393H15.4a4.392 4.392 0 0 0-4.392 4.393v3.152Z"
      stroke="currentColor"
      strokeWidth={2}
    />
    <path
      d="M11.322 7.141a3.972 3.972 0 0 0 3.843 2.97h1.657c1.847 0 3.4-1.261 3.843-2.97h-9.343ZM19 17a3 3 0 1 1-6 0"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
)
